import { createMuiTheme } from '@material-ui/core/styles'

export const main = createMuiTheme({
  palette: {
    primary: { main: '#003636' },
    secondary: { main: '#003636' },
  },
  overrides: {
    MuiInputLabel: {
      filled: {
        '&$shrink': {
          transform: 'translate(12px, 5px) scale(0.75)',
        },
      },
    },
  },
})
